import { replace } from 'lodash';
import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}

// checks if a string is Numeric
export function isStringNumeric(str) {
  if (typeof str !== 'string') return false; // we only process strings!
  return /^\d+$/.test(str);
}

// formats cpu from millicores to cores eg. 2000 -> 2
export function formatCPUToCores(milli) {
  if (!milli) return null;
  return Math.round((milli / 1000) * 100) / 100;
}

// formats memory from bytes to MB eg. 2000000000 to 2000
export function formatMemoryToMB(bytes) {
  if (!bytes) return null;
  const MB = bytes / 1_000_000;
  return Math.round(MB);
}
